import { InteractionType } from '@azure/msal-browser';
import { MsalInterceptorConfiguration, ProtectedResourceScopes } from '@azure/msal-angular';
import { protectedResources } from './auth-config';

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string | ProtectedResourceScopes> | null>();

  protectedResources.endpoint.forEach(endpoint => {
    protectedResourceMap.set(endpoint,
      [...protectedResources.scopes.all]
    );
  })

  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap,
  };
}
